import React, { useState } from 'react'
import { Route } from 'react-router-dom'

import { routes } from 'constants/routes'
import General from '../../pages/GeneralSettings'
import PersonalTokens from '../../pages/PersonalTokens'

import localStorageKeys from 'constants/localStorageKeys'

import { PageWrapper } from './SettingsView.styles'
import { useGetWorkspaces } from 'modules/workspace/operations'
import { getItem } from 'utils/localStorage'

import { DynamicLoadingPage } from 'containers/DynamicLoadingPage'
import GenericErrorView from 'views/GenericErrorView'

import WorkspaceSidebarLayout from 'modules/workspace/components/WorkspaceSidebarLayout'

const SettingsView = () => {
  const [workspaceId] = useState<string | undefined>(
    getItem(localStorageKeys.lastWorkspaceIdKey)
  )
  const { workspaces, loading, error } = useGetWorkspaces()

  if (loading) {
    return <DynamicLoadingPage />
  }

  if (error) {
    return <GenericErrorView error={error} />
  }

  const currentWorkspace =
    workspaces?.find(({ identifier }) => workspaceId === identifier) ||
    workspaces?.[0]

  return (
    <WorkspaceSidebarLayout
      title="Settings"
      currentWorkspace={currentWorkspace}
      workspaces={workspaces}>
      <PageWrapper>
        <Route
          exact
          path={[
            routes.PERSONAL_SETTINGS.template(),
            routes.PERSONAL_SETTINGS_UNSUBSCRIBE.template(),
            routes.PERSONAL_SETTINGS_CONFIRM_DISABLE_MFA.template(),
          ]}>
          <General />
        </Route>
        <Route exact path={routes.PERSONAL_SETTINGS_API_KEYS.template()}>
          <PersonalTokens />
        </Route>
      </PageWrapper>
    </WorkspaceSidebarLayout>
  )
}

export default SettingsView
